<footer class="tg-footer">
  <div class="tg-footer__inner">

    <!-- Top row -->
    <div class="tg-footer__top">

      <!-- Brand -->
      <div class="tg-footer__brand">
        <img src="assets/img/logo.png" alt="TG Empleos" height="56" class="tg-footer__logo" style="background:#fff;border-radius:10px;padding:6px 10px;">
        <p>Conectamos talento tech con las mejores oportunidades de México y Latinoamérica.</p>
        <div class="tg-footer__social">
          <a href="https://www.facebook.com/TecGurusNet/" target="_blank" aria-label="Facebook">
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
          </a>
          <a href="https://twitter.com/TecGurusNet/" target="_blank" aria-label="Twitter / X">
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M4 4l16 16M4 20 20 4" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"/></svg>
          </a>
          <a href="https://www.instagram.com/TecGurusNet/" target="_blank" aria-label="Instagram">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r=".5" fill="currentColor"/></svg>
          </a>
          <a href="https://www.youtube.com/channel/UCAFYtU3EzN1SjYty13Ph_FQ" target="_blank" aria-label="YouTube">
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="white"/></svg>
          </a>
          <a href="https://www.linkedin.com/company/tecgurus-gurus/" target="_blank" aria-label="LinkedIn">
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
          </a>
        </div>
      </div>

      <!-- Nav columns -->
      <div class="tg-footer__col">
        <h4>Portal</h4>
        <ul>
          <li><a routerLink="/vacantes">Vacantes</a></li>
          <li *ngIf="!usuarioRol"><a routerLink="/registrarse">Crear cuenta</a></li>
          <li *ngIf="!usuarioRol"><a routerLink="/acceder">Iniciar sesión</a></li>
          <li *ngIf="usuarioRol === 'candidato'"><a routerLink="/mis-cvs">Mis CVs</a></li>
          <li *ngIf="usuarioRol === 'candidato'"><a routerLink="/postulados">Mis postulaciones</a></li>
        </ul>
      </div>

      <div class="tg-footer__col">
        <h4>TecGurus</h4>
        <ul>
          <li><a href="https://tecgurus.net" target="_blank">Cursos y Diplomados</a></li>
          <li><a href="https://portafolio.tecgurus.net/" target="_blank">Portafolio</a></li>
          <li><a href="https://www.expertosti.net/" target="_blank">Desarrollo de Apps</a></li>
          <li><a href="https://www.programaenlinea.net/" target="_blank">Blog / Noticias</a></li>
          <li><a routerLink="/acerca-de-nosotros">Acerca de nosotros</a></li>
        </ul>
      </div>

      <div class="tg-footer__col">
        <h4>Contacto</h4>
        <ul>
          <li>
            <a href="tel:+525552116931">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.8 12.27 19.79 19.79 0 0 1 1.76 3.7 2 2 0 0 1 3.74 1.5h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.16 6.16l1.77-1.77a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              (+52) 55 52 11 69 31
            </a>
          </li>
          <li>
            <a href="mailto:empleos@tecgurus.net">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              empleos@tecgurus.net
            </a>
          </li>
          <li>
            <a [href]="whatsappUrl" target="_blank">
              <svg width="14" height="14" viewBox="0 0 448 512" fill="currentColor"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L1.9 480l117.7-30.9c32.4 17.7 68.9 27 106.2 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-69.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.7-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.6-9.7-1.5-2.8-13.4-32.3-18.3-44.2-4.8-11.8-9.7-10.2-13.4-10.4-3.5-.2-7.5-.2-11.5-.2-4 0-10.5 1.5-16 7.4-5.5 5.9-21.1 20.6-21.1 49.7 0 29.1 21.1 57.4 24 61.6 2.9 4.2 39.4 60.2 95.8 82 56.4 21.8 56.4 14.5 66.5 13.6 10.2-.9 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-4-10.5-6.7z"/></svg>
              WhatsApp
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Bottom bar -->
    <div class="tg-footer__bottom">
      <p>© {{ anio }} <a href="https://tecgurus.net/" target="_blank">TecGurus</a>. Todos los derechos reservados.</p>
      <div style="display:flex;gap:14px;flex-wrap:wrap;">
        <a routerLink="/terminos">Términos y Condiciones</a>
        <a href="https://www.tecgurus.net/privacidad.html" target="_blank" rel="noopener">Aviso de Privacidad</a>
      </div>
    </div>

  </div>
</footer>
